import { useEffect, useState } from "react";
import ReportCatalog from "../components/ReportCatalog";
import type { ReportTileMeta, ReportsResponse } from "../reports";

export default function Home() {
  const [reports, setReports] = useState<ReportTileMeta[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch("/api/reports");
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        const data = (await r.json()) as ReportsResponse;
        if (!cancelled) setReports(data.reports);
      } catch (e) {
        if (!cancelled) setErr(e instanceof Error ? e.message : String(e));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <main
      style={{
        padding: "1.5rem",
        fontFamily: "system-ui, sans-serif",
        maxWidth: "1600px",
        margin: "0 auto"
      }}
    >
      <h1 style={{ marginTop: 0 }}>Prostar Analytics Portal</h1>
      <p style={{ color: "#555", marginTop: "-0.5rem" }}>
        Select a report below.
      </p>
      {err && (
        <p style={{ color: "#b00020" }} data-testid="catalog-error">
          Couldn't load reports: {err}
        </p>
      )}
      {!reports && !err && (
        <p style={{ color: "#555" }} data-testid="catalog-loading">
          Loading reports…
        </p>
      )}
      {reports && reports.length === 0 && (
        <p style={{ color: "#555" }} data-testid="catalog-empty">
          No reports available for your account. Contact your administrator if you expected access.
        </p>
      )}
      {reports && reports.length > 0 && <ReportCatalog reports={reports} />}
    </main>
  );
}
